import React from 'react';
const testimonials = [{
  text: "What I loved most is that the recipes are actually delicious. For the first time, I felt like I could enjoy food without making everything complicated. I've been using the breakfast recipes every single day and my energy levels have improved so much. I finally feel like I have a system that works for me.",
  author: 'Laura M.',
  age: 42,
  condition: 'Hypothyroidism for 6 years'
}, {
  text: 'I never knew what to cook before. Now everything is organized and I feel far less stressed every day. The meal planner has been a game-changer for me. I used to spend hours every week trying to figure out what to make, and now I just follow the plan. My family loves the recipes too!',
  author: 'Patricia R.',
  age: 51,
  condition: 'Hypothyroidism for 8 years'
}, {
  text: "The breakfasts and desserts are amazing. I love having so many options all in one place. I was skeptical at first because I've tried so many different approaches, but this cookbook is different. The recipes are simple, the ingredients are easy to find, and everything tastes incredible. I actually look forward to cooking now.",
  author: 'Andrea G.',
  age: 38,
  condition: 'Hypothyroidism for 4 years'
}, {
  text: 'This cookbook has completely changed how I approach food. I used to feel so overwhelmed and confused about what I should be eating with my thyroid condition. Now I have clear guidance and delicious recipes that actually support my health. The smoothie recipes alone are worth the price. I feel more energized and my brain fog has significantly improved.',
  author: 'Michelle K.',
  age: 45,
  condition: 'Hypothyroidism for 10 years'
}, {
  text: "I wish I had found this years ago. The variety of recipes means I never get bored, and the shopping guide makes grocery trips so much easier. I've lost 12 pounds without even trying because I'm finally eating foods that work with my body instead of against it. My doctor even noticed improvements in my thyroid levels at my last checkup.",
  author: 'Jennifer S.',
  age: 49,
  condition: 'Hypothyroidism for 7 years'
}];
export function Testimonials() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-8" data-id="element-115">
          What Our Customers Are Saying
        </h2>

        <div className="space-y-6" data-id="element-116">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-sage/30 p-6 rounded-lg" data-id="element-117">
              <div className="flex gap-1 mb-3 text-brand-gold text-xl" data-id="element-118">
                {'★★★★★'}
              </div>
              <p className="text-brand-text-dark mb-4 leading-relaxed italic" data-id="element-119">
                "{t.text}"
              </p>
              <div className="border-t border-brand-sage/20 pt-4" data-id="element-120">
                <p className="font-bold text-brand-text-dark" data-id="element-121">— {t.author}</p>
                <p className="text-sm text-brand-text-muted" data-id="element-122">
                  {t.age} years old • {t.condition}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}